// SHA-256 of a drawing's stored data URL, as lowercase hex — a file identity the
// page can compare without comparing multi-MB blobs ("is this the same file that
// is already on this drawing?"). Returns null where the Web Crypto API is not
// available (an insecure context); callers then treat the file as unknown, which
// the database handles as "different" — never as "the same".
export async function sha256Hex(text) {
  const subtle = globalThis.crypto?.subtle;
  if (!subtle) return null;
  const digest = await subtle.digest("SHA-256", new TextEncoder().encode(String(text)));
  return [...new Uint8Array(digest)].map(b => b.toString(16).padStart(2, "0")).join("");
}

/** The same file? Unknown (null/empty) hashes are never equal — a missing hash cannot prove sameness. */
export function sameFile(a, b) {
  return !!a && !!b && a === b;
}
